export enum ComponentState {
    SelectActivity,
    SelectRow,
    SelectEmployee,
    SelectContainer,
    SelectContainers,
    CreateRegistration,
    SelectAmountResult,
    SelectAmountAndProductBox,
    SelectProductBox,
    SelectLocation,
    CreateContainerMeasurement,
    SelectBatch,
}
